import { render } from "./gglb.vue?vue&type=template&id=3167dca7&scoped=true&ts=true"
import script from "./gglb.vue?vue&type=script&lang=ts"
export * from "./gglb.vue?vue&type=script&lang=ts"

import "./gglb.vue?vue&type=style&index=0&id=3167dca7&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3167dca7"]])

export default __exports__